export enum MessagingClientTags {
    tag_ClientSide_Error = '[clientside_error]',
    tag_Activity = '[activity]',
    tag_Activity_Ssr = '[activity_ssr]',
}
